(function ($) {

    $(document).ready(function () {
        if ($(".filters-block").length > 0) {
            $('.filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown select').selectBoxIt({
                showEffect: "fadeIn",
                showEffectSpeed: 400,
                hideEffect: "fadeOut",
                hideEffectSpeed: 400
            });
            $('body .filters-block .filter-wrapper .filter-content .wrapper .filter-dropdown .filter select').on('click', function () {
                $(this).parent().toggleClass('text-black');
            });
        }
    });

})(jQuery);